import { render, staticRenderFns } from "./persons.vue?vue&type=template&id=1bc39a45&scoped=true"
import script from "./persons.vue?vue&type=script&lang=js"
export * from "./persons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc39a45",
  null
  
)

export default component.exports